import { useRouter } from 'next/router';

import { useDeviceType } from '@packages/shared';

import type { DesktopDisplayMode } from '../types';
import type { ApiDisplayType } from '../api/rest/types';
import { decodeDisplayMode, encodeDisplayMode, pruneQuery } from '../queryEncoding';

export const DISPLAY_TYPE_TO_MODE: Record<ApiDisplayType, DesktopDisplayMode> = {
  P: 'cards',
  L: 'largeCards',
  T: 'moreInformation',
} as const;

export const useDisplayMode = (apiDisplayType?: ApiDisplayType) => {
  const { isDesktop } = useDeviceType();
  const { push, pathname, query } = useRouter();

  const displayTypeValue = apiDisplayType ?? 'P';
  const displayMode = decodeDisplayMode(query) ?? DISPLAY_TYPE_TO_MODE[displayTypeValue];

  const mobileDisplayMode = displayMode === 'largeCards' ? 'cards' : displayMode;

  const pushDisplayModeChange = (newDisplayMode: DesktopDisplayMode) => {
    push(
      {
        // currently the /c/ prefix is internal-only, and rewritten in the middleware
        pathname: pathname.replace(/^\/c/, ''),
        query: pruneQuery({
          ...query,
          ...encodeDisplayMode(
            newDisplayMode !== DISPLAY_TYPE_TO_MODE[displayTypeValue] ? newDisplayMode : undefined,
          ),
        }),
      },
      undefined,
      { scroll: false },
    );
  };

  return {
    displayMode: isDesktop ? displayMode : mobileDisplayMode,
    pushDisplayModeChange,
  };
};
